import { render, staticRenderFns } from "./user-exchange-list-type.vue?vue&type=template&id=68a2f1ad&scoped=true&"
import script from "./user-exchange-list-type.vue?vue&type=script&lang=js&"
export * from "./user-exchange-list-type.vue?vue&type=script&lang=js&"
import style0 from "./user-exchange-list-type.vue?vue&type=style&index=0&id=68a2f1ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2f1ad",
  null
  
)

export default component.exports